export default (target, callback) => {
    const handleClick = (e) => {
        if (!e.target.closest(target)) {
            callback(e);
            document.removeEventListener("click", handleClick);
        }
    }
    document.addEventListener("click", handleClick);
};